module.exports = __webpack_public_path__ + "static/media/background.7b4356eb.png";